import React from "react";
import { Link } from "react-router-dom";
import { Clock, CalendarDays, Weight, ArrowRight } from "lucide-react";
import { cdn } from "@/lib/img";
import { STATUT, fmtEur, fmtInt, occPath, occTitle, poidsLabel } from "@/lib/occasions";

export function StatutBadge({ statut, className = "" }) {
  const s = STATUT[statut] || STATUT.disponible;
  return <span className={`inline-block px-2.5 py-1 rounded-sm text-[10px] font-black uppercase tracking-widest ${s.cls} ${className}`} data-testid="occasion-statut">{s.label}</span>;
}

export default function OccasionCard({ o }) {
  const sold = o.statut === "vendu";
  return (
    <Link to={occPath(o)} data-testid={`occasion-card-${o.slug}`} className="group bg-white border border-gray-200 rounded-sm overflow-hidden flex flex-col hover:border-[#D8B86A] hover:shadow-lg transition-[border-color,box-shadow]">
      <div className="relative aspect-[4/3] bg-[#F3F4F6] overflow-hidden">
        {o.photos?.[0] ? (
          <img src={cdn(o.photos[0], 640)} alt={`Mini-pelle d'occasion ${occTitle(o)}${o.annee ? ` ${o.annee}` : ""}`} loading="lazy" decoding="async"
            className={`w-full h-full object-cover transition-transform duration-500 group-hover:scale-105 ${sold ? "grayscale-[60%] opacity-80" : ""}`} />
        ) : <div className="w-full h-full flex items-center justify-center text-xs text-[#4B5563]">Photo à venir</div>}
        <StatutBadge statut={o.statut} className="absolute top-3 left-3" />
        {o.photos?.length > 1 && <span className="absolute bottom-3 right-3 bg-black/60 text-white text-[10px] font-mono-tech px-2 py-0.5 rounded-sm">{o.photos.length} photos</span>}
      </div>
      <div className="p-4 sm:p-5 flex-1 flex flex-col">
        <div className="text-[10px] font-mono-tech tracking-widest text-[#D8B86A] uppercase mb-1">Occasion · {o.marque}</div>
        <h3 className="font-heading text-xl font-black text-[#072135] leading-tight mb-1">{occTitle(o)}</h3>
        <div className="text-xs text-[#4B5563] mb-3 min-h-[1rem]">{[o.version, o.godets?.length && `${o.godets.length} godet${o.godets.length > 1 ? "s" : ""}`, o.usure_chenilles && `chenilles ${o.usure_chenilles === "Neuve" ? "neuves" : o.usure_chenilles}`].filter(Boolean).join(" · ")}</div>
        <div className="flex flex-wrap gap-x-4 gap-y-1.5 text-xs text-[#364757] font-mono-tech mb-4">
          {o.annee && <span className="inline-flex items-center gap-1"><CalendarDays size={13} className="text-[#D8B86A]" /> {o.annee}</span>}
          {o.heures != null && <span className="inline-flex items-center gap-1"><Clock size={13} className="text-[#D8B86A]" /> {fmtInt(o.heures)} h</span>}
          {o.poids_kg && <span className="inline-flex items-center gap-1"><Weight size={13} className="text-[#D8B86A]" /> {poidsLabel(o.poids_kg)}</span>}
        </div>
        <div className="mt-auto flex items-end justify-between gap-2 pt-3 border-t border-gray-100">
          {sold ? <span className="font-heading font-black text-[#4B5563] text-lg">Vendue</span> : (
            <div><span className="lmb-price text-2xl">{fmtEur(o.prix)} €</span> <span className="text-[11px] text-[#4B5563] font-mono-tech">{o.prix_mention}</span></div>
          )}
          <span className="text-xs font-bold text-[#2877C2] inline-flex items-center gap-1 group-hover:gap-2 transition-[gap]">Voir <ArrowRight size={13} /></span>
        </div>
      </div>
    </Link>
  );
}
